import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { financialService } from '../services/financial';
import {
  StyledDebugContainer,
  StyledSection,
  StyledTitle,
  StyledCode,
  StyledButton,
  StyledStatus,
} from './DebugPage.styles';

export const DebugPage: React.FC = () => {
  const { user, isAuthenticated } = useAuth();
  const [apiTest, setApiTest] = useState<any>(null);
  const [loading, setLoading] = useState(false);

  const testFinancialAPI = async () => {
    setLoading(true);
    try {
      const response = await financialService.getOverview();

      setApiTest({ success: true, data: response });
    } catch (error: any) {
      setApiTest({
        success: false,
        error: error.message,
        response: error.response?.data,
      });
    } finally {
      setLoading(false);
    }
  };

  const testDebugEndpoint = async () => {
    setLoading(true);
    try {
      const response = await fetch('http://localhost:3001/api/financial/debug');
      const data = await response.json();

      setApiTest({ success: true, data, endpoint: 'debug' });
    } catch (error: any) {
      setApiTest({
        success: false,
        error: error.message,
        endpoint: 'debug',
      });
    } finally {
      setLoading(false);
    }
  };

  const getStoredData = () => ({
    token: localStorage.getItem('token'),
    user: localStorage.getItem('user'),
    hasToken: !!localStorage.getItem('token'),
  });

  return (
    <StyledDebugContainer>
      <StyledTitle>Debug Authentication & API</StyledTitle>

      <StyledSection>
        <h3>Authentication Status</h3>
        <StyledStatus $type={isAuthenticated ? 'success' : 'error'}>
          Status: {isAuthenticated ? 'Authenticated' : 'Not Authenticated'}
        </StyledStatus>
        <StyledCode>
          {JSON.stringify(
            {
              isAuthenticated,
              user,
              storedData: getStoredData(),
            },
            null,
            2,
          )}
        </StyledCode>
      </StyledSection>

      <StyledSection>
        <h3>API Tests</h3>
        <div>
          <StyledButton onClick={testDebugEndpoint} disabled={loading}>
            Test Debug Endpoint (No Auth)
          </StyledButton>
          <StyledButton onClick={testFinancialAPI} disabled={loading}>
            Test Financial Overview (With Auth)
          </StyledButton>
        </div>

        {loading && <StyledStatus $type='info'>Testing API...</StyledStatus>}

        {apiTest && (
          <div>
            <StyledStatus $type={apiTest.success ? 'success' : 'error'}>
              {apiTest.success ? 'API Call Successful' : 'API Call Failed'}
            </StyledStatus>
            <StyledCode>{JSON.stringify(apiTest, null, 2)}</StyledCode>
          </div>
        )}
      </StyledSection>

      <StyledSection>
        <h3>Local Storage Debug</h3>
        <StyledCode>{JSON.stringify(getStoredData(), null, 2)}</StyledCode>
      </StyledSection>

      <StyledSection>
        <h3>Instructions</h3>
        <p>1. Make sure you're logged in</p>
        <p>2. Test the debug endpoint first (should work without auth)</p>
        <p>3. Test the financial overview endpoint (requires auth)</p>
        <p>4. Check the console and network tab for more details</p>
      </StyledSection>
    </StyledDebugContainer>
  );
};

export default DebugPage;
